export default __webpack_public_path__ + "static/media/ChosainEntrance.1aa49c62.jpg";